import { useMutation } from "@tanstack/react-query";
import { changeAgttp } from "services/agttp";

export const useChangeAgttp = () => {
  return useMutation({
    mutationKey: ["change-agttp"],
    mutationFn: (newAgttp) => changeAgttp(newAgttp),
  });
}; 